module.exports = __webpack_public_path__ + "static/media/item-9.38b6a11e.jpeg";